var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    uploadIconContainerColor: colors.ash,
    uploadIconContainerColorFontSize: typography.fontSizeXLarge,
    checkIconContainerFontSize: typography.fontSizeXLarge,
    checkIconContainerColor: colors.shamrock,
    smallTextFontSize: typography.fontSizeXSmall,
    smallTextColor: colors.ash,
    smallTextPadding: spacing.xSmall,
    selectorMargin: spacing.xSmall,
    fileListSuccessColor: colors.shamrock
  };
};
export default generateComponentTheme;